import React, { useEffect, useState } from 'react';
import { FiMenu } from 'react-icons/fi';
import Sidebar from './Sidebar';
import './Sidebar.css';

const AdminLayout = ({ children, title = 'Admin Dashboard', subtitle = 'Manage your AI workspace, widgets, analytics, and settings.' }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 992) {
        setSidebarCollapsed(false);
      }
      if (window.innerWidth >= 992) {
        setMobileSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="admin-page">
      <Sidebar
        collapsed={sidebarCollapsed}
        setCollapsed={setSidebarCollapsed}
        mobileSidebarOpen={mobileSidebarOpen}
        setMobileSidebarOpen={setMobileSidebarOpen}
      />

      {mobileSidebarOpen && (
        <div
          className="admin-sidebar-backdrop"
          onClick={() => setMobileSidebarOpen(false)}
        />
      )}

      <main
        className={`admin-main ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}
        style={{
          marginLeft: sidebarCollapsed ? '84px' : '260px',
        }}
      >
        <div className="admin-main__header">
          <button
            type="button"
            className="admin-mobile-menu-btn d-lg-none"
            onClick={() => setMobileSidebarOpen(true)}
          >
            <FiMenu />
          </button>
          <h1 className="admin-main__title">{title}</h1>
          <p className="admin-main__subtitle">{subtitle}</p>
        </div>

        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
